import { MediumLogo } from './MediumLogo.component';

export default MediumLogo;
